import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import InputComponent from 'app_components/commons/Input/InputComponent'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import { CombinedReducers } from 'app_events/index'
import { IUserCertification } from 'app_types/campus/user/userInfoTypes'
import moment from 'moment'
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import StudentDashboardCertificationsTable from '../StudentDashboardCertificationsTable/StudentDashboardCertificationsTable'

import './StudentDashboardCertifications.scss'
import UserDataService from 'app_services/campus/user/userService';

const INPUT_DATE_FORMAT = 'YYYY-MM-DD'

const StudentDashboardCertifications: FC = () => {
  const [searchText, setSearchText] = useState<string>('')
  const [dateFrom, setDateFrom] = useState<string | null>(null)
  const [dateTo, setDateTo] = useState<string | null>(null)
  const [certifications, setCertifications] = useState<IUserCertification[]>([])
  const [certificationsToRender, setCertificationsToRender] = useState<IUserCertification[]>([])
  const user = useSelector((state: CombinedReducers) => state.auth?.user?.data)
  const userId = useMemo(() => user?.id, [user])
  const userDataService = useMemo(() => new UserDataService(), [])

  const isValidSearchButton = useMemo(() => {
    if (searchText?.trim()?.length || dateFrom || dateTo) return true
    return false
  }, [searchText, dateFrom, dateTo])

  const getCertifications = useCallback(async () => {
    if (userId && userDataService) {
      const userDataInfoResponse = await userDataService.fetchUserInfo(userId)
      if (userDataInfoResponse && userDataInfoResponse?.user) {
        let userInfo: any = {...userDataInfoResponse.user}
        if (userInfo?.certifications?.length) {
          setCertifications(userInfo.certifications)
          setCertificationsToRender([...userInfo.certifications])
        } else {
          setCertifications([])
          setCertificationsToRender([])
        }
      }
    }
  }, [userDataService, userId])

  useEffect(() => {
    getCertifications()
  }, [getCertifications])

  const handleClickClean = () => {
    setSearchText('')
    setDateFrom(null)
    setDateTo(null)
    setCertificationsToRender([...certifications])
  }

  const handleClickSearch = () => {
    const newCertifications: IUserCertification[]= certifications?.filter(({ title, date }) => {
      if (searchText?.trim()?.length && !title.toLowerCase().includes(searchText.toLowerCase())) return false
      if (dateFrom && !moment(date).isSameOrAfter(moment(dateFrom))) return false
      if (dateTo && !moment(date).isSameOrBefore(moment(dateTo))) return false
      return true
    })
    setCertificationsToRender(newCertifications?.length ? newCertifications : [])
  }

  return (
    <div className="student-dashboard-certifications--layout">
      <TextComponent type='subtitle'>Certificados</TextComponent>
      <div className="student-dashboard-certifications--actions">
        <InputComponent
          label="Nombre"
          placeholder='Nombre'
          onChange={(e) => setSearchText(e.target.value)}
          value={searchText}
        />
        <InputComponent
          type="date"
          label="Desde"
          placeholder='Desde'
          value={dateFrom ? moment(dateFrom).format(INPUT_DATE_FORMAT) : ''}
          onChange={(e) => setDateFrom(e.target.value)}
        />
        <InputComponent
          type="date"
          label="Hasta"
          placeholder='Hasta'
          value={dateTo ? moment(dateTo).format(INPUT_DATE_FORMAT) : ''}
          onChange={(e) => setDateTo(e.target.value)}
        />
        <ButtonComponent
          disabled={!isValidSearchButton}
          onClick={handleClickSearch}
          variant='primary'
        >
          Buscar
        </ButtonComponent>
        <ButtonComponent
          disabled={!isValidSearchButton}
          onClick={handleClickClean}
          variant='tertiary'
        >
          Limpiar
        </ButtonComponent>
      </div>
      <StudentDashboardCertificationsTable
        certificationsToRender={certificationsToRender}
      />
      <TextComponent>
        Si no encuentra en este cuadro el certificado del curso que ha tomado con Icontec, por favor revise si usted ha cumplido con todos los requisitos académicos para obtener la certificación según los criterios de aprobación.
      </TextComponent>
    </div>
  )
}

export default StudentDashboardCertifications
